import * as Types from './types';
var initialState = {
    allowBackNavigation: false,
};
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case Types.SET_ALLOW_BACK_NAVIGATION:
            return {
                allowBackNavigation: action.allowBackNavigation,
            };
    }
    return state;
};
export default reducer;
